import React from "react";
import { useAppointmentFees } from "../../../hooks/useAppointmentFees";
import { useContext } from "../../../context";
import { FEE_MODAL_TYPE } from "../../Modals/Fee/config";
import { useMarkNoShow } from "../../../hooks/useMarkNoShow";

export function NoShow() {
  const { modals, onClose, refetchAppointments } = useContext();
  const { cancelationFee } = useAppointmentFees();
  const markNoShow = useMarkNoShow();

  const onMarkNoShow = () => {
    if (cancelationFee) {
      modals.fee.open({
        type: FEE_MODAL_TYPE.noShow,
        cancelationFee,
      });
    } else {
      markNoShow.initiate({ charge: false }).then(() => {
        refetchAppointments();
        onClose();
      });
    }
  };

  return (
    <button
      className="new-yellow-btn"
      onClick={onMarkNoShow}
      disabled={markNoShow.isLoading}
    >
      {markNoShow.isLoading ? "Marking as No Show..." : "Mark as No Show"}
    </button>
  );
}
